import React, { useState, useEffect } from 'react'
import navIcon from '../../images/nav-icon2.png'
import { Link, NavLink } from 'react-router-dom'

function Header() {
    const [open, setOpen] = useState(false);
    const handleClick = () =>{
        setOpen(!open)
    }

    return (
        <>
            <header className="header">
                <nav className='main-nav'>
                    <div className={`nav`}>
                        <div className="icon">
                            <Link to='/'> <img src={navIcon} alt="" /></Link>
                        </div>
                        <ul className={`nav-items  ${open ? 'active' : ''} }`}>
                            <li><NavLink to="/">Home</NavLink></li>
                            <li><NavLink to="about-me">About-Me & Experience</NavLink></li>
                            <li><NavLink to="case-study">Case-Study</NavLink></li>
                            <li><NavLink to="dummy-projects">Dummy Projects</NavLink></li>
                            <li><NavLink to="contact">Contact</NavLink></li>
                        </ul>
                        <div className="header-close" onClick={handleClick}> {open ? '✖' : '☰'}
                            {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" /></svg> */}
                        </div>
                    </div>
                </nav>

            </header>

        </>
    )
}

export default Header